import { useState } from 'react'
import { Icon } from '@iconify/react'
import { Button, Drawer, useAuthState, Spin } from '@pepper/ui'

import ScreenImage from 'assets/images/screen_image.png'

import s from './MobileWarning.module.css'

export const MobileWarning = () => {
  const [open, setOpen] = useState(true)
  const [didLoad, setDidLoad] = useState(false)
  const { logout } = useAuthState()

  const title = (
    <div className={s.drawerHeader}>
      <Icon icon="lucide:alert-circle" height={20} width={20} color="#F59F0A" />
      <div className={s.headerText}>Better on the big screen</div>
    </div>
  )

  return (
    <Drawer
      title={title}
      placement="bottom"
      visible={open}
      onClose={() => setOpen(false)}
      height={325}
      bodyStyle={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <div className={s.imgContainer}>
        {!didLoad && <Spin spinning={true} />}
        <img
          style={{ display: didLoad ? 'inline' : 'none' }}
          src={ScreenImage}
          alt="mobile warning"
          height={140}
          role="none"
          onLoad={() => setDidLoad(true)}
        />
        <div className={s.helpText}>
          Our platform is best able to help you on a desktop
        </div>
      </div>
      <div className={s.logoutBtnContainer}>
        <Button className={s.logoutBtn} onClick={logout}>
          Log Out
        </Button>
      </div>
    </Drawer>
  )
}
